import React from 'react';
import {useNavigate} from 'react-router-dom';

function getDisplayImage(images) {
  if (!images || images.length === 0) return null;
  
  const mainImage = images.find(img => img.mainImage);
  
  if (mainImage) return mainImage;
  
  return [...images].sort(function(a, b) { return a.ordinal - b.ordinal; })[0];
}

function ProjectCard({ project, onDelete }) {
  const navigate = useNavigate();
  const firstImage = getDisplayImage(project.images);

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      {firstImage ? (
        <img
          src={firstImage.url}
          alt={project.header}
          className="w-full h-48 object-cover"
        />
      ) : (
        <div className="w-full h-48 bg-gray-200 flex items-center justify-center">
          <span className="text-gray-400">No image</span>
        </div>
      )}

      <div className="p-4">
        <h3 className="text-lg font-semibold text-[#081542] mb-2">
          {project.header}
        </h3>
        <span className="inline-block px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded">
          {project.projectType}
        </span>
      </div>

      <div className="px-4 pb-4 flex gap-2">
        <button
          type="button"
          onClick={function() { navigate(`/admin/update/${project.id}`); }}
          className="flex-1 py-2 px-4 bg-[#081542] text-white rounded hover:bg-[#0d1f79] transition-colors"
        >
          Update
        </button>
        <button
          type="button"
          className="flex-1 py-2 px-4 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
          onClick={function() { onDelete(project.id); }}
        >
          Delete
        </button>
      </div>
    </div>
  );
}

export default ProjectCard;
